// journeyNote.js
// "in progress N%" / "done" note shown next to a mission/journey pill once
// useJourneyMap resolves that journey's per-student progress. Extracted
// from ExploreSection.js so components/header/programsMenu.js can reuse it
// for the "Programs ▾" nav menu items — see
// docs/superpowers/specs/2026-09-16-home-redesign.md §11 WP10 (step 2).
//
const journeyNote = (progress, t = (s) => s) => {
  if (!progress) return null;
  if (progress.completed) return t("done");
  if (progress.started) return t("in progress {percent}%", { percent: progress.percent });
  return null;
};

export default journeyNote;
